export const UserCapacityService = Symbol.for('UserCapacityService');
